import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const msiApi = createApi({
  reducerPath: 'msiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_EVENT}/payment-methods-query/api/v1`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['Msi'],
  endpoints: (builder) => ({
    getMsi: builder.query({
      query: (value) => `cards/bins/${value}`,
      providesTags: ['msiSearch'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetMsiQuery, useLazyGetMsiQuery } = msiApi;
